import { useEffect } from "react";

export default function SignupButtonBehaviour() {

  useEffect(() => {

// ==========================
// INPUTS
// ==========================
const form = document.querySelector("form");
const firstName = document.getElementById("firstNameInput");
const lastName = document.getElementById("lastNameInput");
const email = document.getElementById("emailInput");
const password = document.getElementById("passwordInput");
const confirmPassword = document.getElementById("confirmPasswordInput");
const checkbox = document.getElementById("flexCheckDefault");
const termsError = document.getElementById("termsError");

// ==========================
// REGEX
// ==========================
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// ==========================
// HELPER
// ==========================
function setError(input) {
    input.closest(".custom-floating").classList.add("error");
}

function removeError(input) {
    input.closest(".custom-floating").classList.remove("error");
}

// ==========================
// VALIDATION
// ==========================
form.addEventListener("submit", function (e) {
    e.preventDefault(); // always block submission first; only allow below if fully valid

    let isValid = true;

    // First Name
    if (!firstName.value.trim()) {
        setError(firstName);
        isValid = false;
    } else removeError(firstName);

    // Last Name
    if (!lastName.value.trim()) {
        setError(lastName);
        isValid = false;
    } else removeError(lastName);

    // Email
    if (!emailRegex.test(email.value.trim())) {
        setError(email);
        isValid = false;
    } else removeError(email);

    // Phone (intl-tel-input validation)
    try {
        if (!phoneInput.value.trim() || !iti.isValidNumber()) {
            setError(phoneInput);
            isValid = false;
        } else removeError(phoneInput);
    } catch (_) {
        // phoneInput / iti not available — skip phone validation
    }

    // Password
    if (password.value.length < 6) {
        setError(password);
        isValid = false;
    } else removeError(password);

    // Confirm Password
    if (confirmPassword.value !== password.value || !confirmPassword.value) {
        setError(confirmPassword);
        isValid = false;
    } else removeError(confirmPassword);

    // Terms & Conditions checkbox — must be checked
    if (!checkbox.checked) {
        checkbox.classList.add("is-invalid");
        if (termsError) termsError.style.display = "block";
        isValid = false;
    } else {
        checkbox.classList.remove("is-invalid");
        if (termsError) termsError.style.display = "none";
    }

    if (isValid) {
        form.submit(); // only submit when all validations pass
    }
});

// ==========================
// LIVE FEEDBACK (smooth UX)
// ==========================
document.querySelectorAll("input").forEach(input => {
    input.addEventListener("input", function () {
        if (this.value.trim()) {
            removeError(this);
        }
    });
});

checkbox.addEventListener("change", function () {
    if (this.checked) {
        this.classList.remove("is-invalid");
        if (termsError) termsError.style.display = "none";
    }
});
  }, []);

  return null;
}
